import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const NoEventData: FC = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                width: '85%',
                mx: 'auto',
                mt: 4,
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                alignItems: 'center',
            }}
        >
            {/* 🔙 Back Button */}
            <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/')} sx={{ alignSelf: 'flex-start' }}>
                Back to Events
            </Button>

            {/* ❌ Error Message */}
            <Paper
                sx={{
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                    textAlign: 'center',
                    backgroundColor: 'error.lighter', // subtle MUI error background
                    color: 'error.main',
                    width: '100%',
                }}
            >
                <Typography variant="h4" fontWeight={700} gutterBottom>
                    Event data not found
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    The event you are looking for could not be loaded. Please check back later or go back to the events
                    list.
                </Typography>
            </Paper>
        </Box>
    );
};
